<template>
  <div  :style="{'width': '1880px', height: (height - 82) + 'px'}" style="margin: 0 auto">
    <div class="diagram sub-left" style="margin: 0 auto;width: 100%;position: relative">
      <div style="z-index: 998;position: absolute;left: 1rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">2ES环境参数（1）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES2T02', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES2T02', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES2Y02', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES2S02', 3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 12rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">2ES环境参数（2）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES2T01', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES2T01', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES2Y01', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES2S01', 3)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="z-index: 998;position: absolute;left: 29.6rem;top: 2.6rem;" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '45.70A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5989.7V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '450kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 46.5rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '21.8A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5961.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '216.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.96'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 76rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.3A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5992.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '43.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.97'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 92.5rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.50A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5923.6V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '44.3kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>


      <img src="../../assets/img/es2.svg" alt="ES2背景图" class="bg-diagram" draggable="false" style="height: auto;position: absolute;left: 0;top: 0">
      <div>
        <SignalNode node-title="D2-1AN13" type="1" info="柴发进线柜"  :context="context" node-style="position: absolute;width: 7.1rem;height: auto;left: 72.26rem;top: 27.5rem;background-color: transparent"></SignalNode>

        <SignalNode node-title="J331" info="331进线隔离小车" :context="context" node-style="left: 28.16rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="2-#1变压器322开关小车" node-title="J332" node-style="left: 45.0rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="431进线隔离小车" node-title="J431" node-style="left: 73.97rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="2-#2变压器432开关小车" node-title="J432" node-style="left: 90.8rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D2-1AN1" node-style="left: 2.66rem;top: 17.65rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D2-1AN2" node-style="left: 5.4rem;top: 17.65rem;"></SignalNode>
        <SignalNode :context="context" info="2-#1变压器进线柜" node-title="D2-1AN3" node-style="left: 10.9rem;top: 17.65rem;"></SignalNode>
        <SignalNode :context="context" info="滤波装置" node-title="D2-1AN4" node-style="left: 13.9rem;top: 17.65rem;"></SignalNode>

        <SignalNode :context="context" info="安全照明（备用）" node-title="D2-1AN5-1" node-style="left: 17.2rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="端屏（主用）" node-title="D2-1AN5-2" node-style="left: 19.85rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱" node-title="D2-1AN5-3" node-style="left: 22.5rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="电梯" node-title="D2-1AN5-4" node-style="left: 25.2rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D2-1AN5-5" node-style="left: 27.8rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN5-6" node-style="left: 30.5rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN5-7" node-style="left: 33.2rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN5-8" node-style="left: 35.85rem;top: 17.3rem;"></SignalNode>

        <SignalNode :context="context" info="厨房用电" node-title="D2-1AN6-1" node-style="left: 40.55rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="厨房用电" node-title="D2-1AN6-2" node-style="left: 43.5rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="空调风机总箱" node-title="D2-1AN6-3" node-style="left: 46.4rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="草坪补光系统" node-title="D2-1AN6-4" node-style="left: 49.4rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D2-1AN6-5" node-style="left: 52.27rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN6-6" node-style="left: 55.2rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN6-7" node-style="left: 58.095rem;top: 17.3rem;"></SignalNode>


        <SignalNode :context="context" info="商业" node-title="D2-1AN7-1" node-style="left: 62.45rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D2-1AN7-2" node-style="left: 65.3rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="游泳馆照明（总箱）" node-title="D2-1AN7-3" node-style="left: 68.2rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（备用）" node-title="D2-1AN7-4" node-style="left: 71.0rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="风机水泵总箱" node-title="D2-1AN7-5" node-style="left: 73.91rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN7-6" node-style="left: 76.8rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN7-7" node-style="left: 79.7rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN7-8" node-style="left: 82.5rem;top: 17.3rem;"></SignalNode>


        <SignalNode :context="context" info="照明总箱1" node-title="D2-1AN8-1" node-style="left: 87.04rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="锅炉房" node-title="D2-1AN8-2" node-style="left: 89.75rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="运营商机房（备用）" node-title="D2-1AN8-3" node-style="left: 92.41rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（备用）" node-title="D2-1AN8-4" node-style="left: 95.15rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="照明箱" node-title="D2-1AN8-5" node-style="left: 97.79rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="室外景观箱" node-title="D2-1AN8-6" node-style="left: 100.5rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="场地工艺（主用）" node-title="D2-1AN8-7" node-style="left: 103.16rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN8-8" node-style="left: 105.86rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN8-9" node-style="left: 108.55rem;top: 17.3rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN8-10" node-style="left: 111.25rem;top: 17.3rem;"></SignalNode>

        <SignalNode :context="context" info="母联柜" node-title="D2-1AN9" node-style="left: 115.35rem;top: 17.54rem;"></SignalNode>


        <SignalNode :context="context" info="普通排水泵总箱（主用）" node-title="D2-1AN10-1" node-style="left: 2.323rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="弱电进线间（备用）" node-title="D2-1AN10-2" node-style="left: 4.97rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="35kV站用电（备用）" node-title="D2-1AN10-3" node-style="left: 7.65rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="弱电间电源总箱（备用）" node-title="D2-1AN10-4" node-style="left: 10.25rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="生活热水换热机房" node-title="D2-1AN10-5" node-style="left: 12.9rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D2-1AN10-6" node-style="left: 15.54rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D2-1AN10-7" node-style="left: 18.16rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN10-8" node-style="left: 20.8rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN10-9" node-style="left: 23.45rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN10-10" node-style="left: 26.08rem;top: 29.6rem;"></SignalNode>

        <SignalNode :context="context" info="消防电源（主用）" node-title="D2-1AN11-1" node-style="left: 28.68rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源总箱（主用）" node-title="D2-1AN11-2" node-style="left: 31.35rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D2-1AN11-3" node-style="left: 34rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D2-1AN11-4" node-style="left: 36.65rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（主用）" node-title="D2-1AN11-5" node-style="left: 39.25rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D2-1AN11-6" node-style="left: 41.9rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN11-7" node-style="left: 44.5rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN11-8" node-style="left: 47.16rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN11-9" node-style="left: 49.8rem;top: 29.6rem;"></SignalNode>

        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D2-1AN12-1" node-style="left: 52.46rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D2-1AN12-2" node-style="left: 55.1rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN12-3" node-style="left: 57.71rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="L1层游泳馆（主用）" node-title="D2-1AN12-4" node-style="left: 60.35rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN12-5" node-style="left: 63rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN12-6" node-style="left: 65.65rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN12-7" node-style="left: 68.25rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN12-8" node-style="left: 70.91rem;top: 29.6rem;"></SignalNode>

        <SignalNode :context="context" info="场地照明（主用）" node-title="D2-1AN14-1" node-style="left: 81.91rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="功放设备（主用）" node-title="D2-1AN14-2" node-style="left: 84.5rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D2-1AN14-3" node-style="left: 87.15rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D2-1AN14-4" node-style="left: 89.79rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D2-1AN14-5" node-style="left: 92.4rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="体育工艺用电（主用）" node-title="D2-1AN14-6" node-style="left: 95.01rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN14-7" node-style="left: 97.6rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN14-8" node-style="left: 100.23rem;top: 29.6rem;"></SignalNode>

        <SignalNode :context="context" info="备用" node-title="D2-1AN15-1" node-style="left: 103.3rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-2" node-style="left: 105.5rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-3" node-style="left: 107.65rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-4" node-style="left: 109.8rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-5" node-style="left: 111.96rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-6" node-style="left: 114.15rem;top: 29.6rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-1AN15-7" node-style="left: 116.3rem;top: 29.6rem;"></SignalNode>

        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D2-2AN12-1" node-style="left: 2.323rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D2-2AN12-2" node-style="left: 4.86rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN12-3" node-style="left: 7.46rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="L1层游泳馆（备用）" node-title="D2-2AN12-4" node-style="left: 10.0rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN12-5" node-style="left: 12.6rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN12-6" node-style="left: 15.16rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN12-7" node-style="left: 17.75rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN12-8" node-style="left: 20.3rem;top: 42.44rem;"></SignalNode>


        <SignalNode :context="context" info="消防电源（备用）" node-title="D2-2AN11-1" node-style="left: 22.9rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源总箱（备用）" node-title="D2-2AN11-2" node-style="left: 25.46rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D2-2AN11-3" node-style="left: 28rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D2-2AN11-4" node-style="left: 30.56rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（备用）" node-title="D2-2AN11-5" node-style="left: 33.12rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D2-2AN11-6" node-style="left: 35.7rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN11-7" node-style="left: 38.277rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN11-8" node-style="left: 40.85rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN11-9" node-style="left: 43.43rem;top: 42.44rem;"></SignalNode>

        <SignalNode :context="context" info="弱电进线间（主用）" node-title="D2-2AN10-1" node-style="left: 46.0rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="运营商机房（主用）" node-title="D2-2AN10-2" node-style="left: 48.56rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="35kV站用电（主用）" node-title="D2-2AN10-3" node-style="left: 51.15rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（主用）" node-title="D2-2AN10-4" node-style="left: 53.69rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱2" node-title="D2-2AN10-5" node-style="left: 56.29rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="弱电间电源总箱（主用）" node-title="D2-2AN10-6" node-style="left: 58.85rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN10-7" node-style="left: 61.41rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN10-8" node-style="left: 64.0rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN10-9" node-style="left: 66.55rem;top: 42.44rem;"></SignalNode>

        <SignalNode :context="context" info="除湿机（自带控制箱）" node-title="D2-2AN9-1" node-style="left: 69.15rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="除湿机（自带控制箱）" node-title="D2-2AN9-2" node-style="left: 71.7rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="除湿机（自带控制箱）" node-title="D2-2AN9-3" node-style="left: 74.28rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="普通风机总箱" node-title="D2-2AN9-4" node-style="left: 76.86rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="普通排水泵总箱（备用）" node-title="D2-2AN9-5" node-style="left: 79.46rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="冷却塔" node-title="D2-2AN9-6" node-style="left: 82.0rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="场地工艺（备用）" node-title="D2-2AN9-7" node-style="left: 84.58rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN9-8" node-style="left: 87.15rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN9-9" node-style="left: 89.7rem;top: 42.44rem;"></SignalNode>

        <SignalNode :context="context" info="厨房用电" node-title="D2-2AN8-1" node-style="left: 92.27rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="游泳池水处理机房" node-title="D2-2AN8-2" node-style="left: 94.84rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="训练池水处理机房" node-title="D2-2AN8-3" node-style="left: 97.38rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="戏水池水处理机房" node-title="D2-2AN8-4" node-style="left: 99.96rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="体育工艺" node-title="D2-2AN8-5" node-style="left: 102.54rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D2-2AN8-6" node-style="left: 105.14rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D2-2AN8-7" node-style="left: 107.68rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN8-8" node-style="left: 110.29rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN8-9" node-style="left: 112.85rem;top: 42.44rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN8-10" node-style="left: 115.4rem;top: 42.44rem;"></SignalNode>



        <SignalNode :context="context" info="照明总箱" node-title="D2-2AN7-1" node-style="left: 3.12rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="广告" node-title="D2-2AN7-2" node-style="left: 6.67rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="配套产业" node-title="D2-2AN7-3" node-style="left: 10.2rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="空调风机总箱" node-title="D2-2AN7-4" node-style="left: 13.7rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="草坪低温加热系统" node-title="D2-2AN7-5" node-style="left: 17.25rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="羽毛球球场安全照明（备用）" node-title="D2-2AN7-6" node-style="left: 20.79rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN7-7" node-style="left: 24.35rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN7-8" node-style="left: 27.9rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN7-9" node-style="left: 31.41rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN7-10" node-style="left: 34.91rem;top: 53.85rem;"></SignalNode>


        <SignalNode :context="context" info="场地照明（备用）" node-title="D2-2AN6-1" node-style="left: 38.46rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D2-2AN6-2" node-style="left: 42.0rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="功放设备（备用）" node-title="D2-2AN6-3" node-style="left: 45.5rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="屋顶融雪电伴热" node-title="D2-2AN6-4" node-style="left: 49.05rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="环屏用电" node-title="D2-2AN6-5" node-style="left: 52.55rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="泛光照明配电箱" node-title="D2-2AN6-6" node-style="left: 56.15rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN6-7" node-style="left: 59.65rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN6-8" node-style="left: 63.2rem;top: 53.85rem;"></SignalNode>


        <SignalNode :context="context" info="端屏（备用）" node-title="D2-2AN5-1" node-style="left: 66.73rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D2-2AN5-2" node-style="left: 70.26rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D2-2AN5-3" node-style="left: 73.78rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D2-2AN5-4" node-style="left: 77.34rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="体育工艺供电（备用）" node-title="D2-2AN5-5" node-style="left: 80.85rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN5-6" node-style="left: 84.37rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN5-7" node-style="left: 87.9rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D2-2AN5-8" node-style="left: 91.46rem;top: 53.85rem;"></SignalNode>
        <SignalNode :context="context" info="环屏用电" node-title="D2-2AN5-9" node-style="left: 94.96rem;top: 53.85rem;"></SignalNode>

        <SignalNode :context="context" info="滤波装置" node-title="D2-2AN4" node-style="left: 100.35rem;top: 53.7rem;"></SignalNode>
        <SignalNode :context="context" info="2-#2变压器进线柜" node-title="D2-2AN3" node-style="left: 104.47rem;top: 53.7rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D2-2AN2" node-style="left: 110.04rem;top: 53.7rem;"></SignalNode>
        <SignalNode :context="context" info="动态自动无功补偿" node-title="D2-2AN1" node-style="left: 114.97rem;top: 53.7rem;"></SignalNode>



      </div>
    </div>
  </div>
</template>

<script setup>

import {useSize} from "@/assets/js/size";
import SignalNode from "@/components/system/SignalNode";
import {ref} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useSensorCompute} from "@/assets/js/sensorCompute";
import useUtils from "@/assets/js/utils";
const {height} = useSize();
let context = ref({})
const {alert} = useUtils();

function service(data){
  for (let key in data){
    context.value[key] = data[key];
    if (data[key]?.alert){
      alert.value['es2'] = true;
    }
  }
  context.value['alert'] = alert.value['es2'];
}
useRealTimeDataService(service, 2,{checkFR: true});
let sensorCompute = useSensorCompute(context);
</script>

<style scoped>
.diagram{
  position: relative;
  margin: 70px auto 0;
}
@media screen and (min-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}
@media screen and (max-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}

@media screen and (max-width: 3000px){
  .diagram,.bg-diagram{
    width: 3000px;
  }
}

@media screen and (max-width: 1920px){
  .diagram,.bg-diagram{
    width: 1920px;
  }
}

.diagram,.bg-diagram{
  width: 1920px;
}

.main-table{
  width: 9.5rem;
  height: 6.45rem;

  float:left;
  border:1px solid #666;
  text-align: center;
  color: white;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
}
.main-table-row{
  width: 100%;
  height: 1.5625rem;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
  border-bottom: 1px dashed grey;
  display: flex;
  flex-wrap: nowrap;
}
.main-table-row:last-child{
  border-bottom: none;
}
.main-table-cell{
  flex:0 50px;
}
.main-table-cell:nth-child(1){
  border-right: 1px dashed grey;
}
.main-table-cell:nth-child(2){
  flex:1 0px;
  font-weight: bold;
  font-size: 0.9375rem;
}
.main-table-cell:nth-child(3){
  border-left: 1px dashed grey;
  flex:0 30px;
}

.IA{
  color: #dede12
}
.IB{
  color:#0dd22d
}
.P{
  color: #00ceff;
}
.Q{
  color: #ec4cff;
}
.COS{
  color: #0d86ed ;
}
</style>